// eslint-disable-next-line import/prefer-default-export
export const SET_ADMIN_LIST = 'SET_ADMIN_LIST';
export const SET_ADMIN_INFO = 'SET_ADMIN_INFO';
